import styled from "styled-components";
import { API_CALLS } from "../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../redux";
import { RateContent } from "../../../../../../Common";
import { usePostCardContext } from "../../PostCardContent";

export const PostRateContent = () => {
  const { postId, isWithinRepostModal } = usePostCardContext();
  const { id } = useAppSelector((state) => state.me);
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const original_post = processed_posts[postId];
  const rating = original_post?.interactions?.rating_interaction;

  const onRatingSubmit = (ratingValue: number) => {
    API_CALLS.POSTS.submitAnswerForARateInteraction({
      choice: ratingValue,
      created_at: new Date().toISOString(),
      id: ratingValue <= 50 ? rating?.left_emoji_id : rating?.right_emoji_id,
      slider_id: rating?.id,
      user_id: id,
    });
  };

  return (
    <Container>
      <RateContent
        isWithinRepostModal={isWithinRepostModal}
        onRatingSubmit={onRatingSubmit}
        rating={rating}
      />
    </Container>
  );
};

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
